<template>
  <KaeruWidget
    project="jigsaw"
    board="feature-requests"
    app-mount-path="/feedback/feature-requests"
  />
</template>

<script setup lang="ts">
import KaeruWidget from '../components/KaeruWidget.vue'
</script>
